var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 1500,
    viewBox: "0 0 593 593",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 296.5,
    cy: 296.5,
    r: 264.5,
    stroke: "#fcba88",
    strokeWidth: 64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleShape2);
export default __webpack_public_path__ + "static/media/circle-shape2.37e51238c0419a34bd6c7da4b320aea4.svg";
export { ForwardRef as ReactComponent };